// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"39db40af","377":"4e5f0333","510":"ac5aec8f","791":"76038515"}[chunkId] + ".chunk.js";
};